import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
import config from '../config'
import { processDataIuran, composeIuran } from '../lib/iuran'
import {request} from './authorized-request'

const verifyKTP = peserta =>
  new Promise(async (resolve, reject) => {
    const { NIK, NoPonsel, NamaLengkap, TglLahir, BlnLahir, ThnLahir } = peserta
    if (NIK === '3921010207976665') {
      resolve({
        status: 'success',
        smsotp: '123456',
        data: {
          "PROP_KTP": "JAWA BARAT",
          "NIK": "3921010207976665",
          "CH_ID": "PASARPOLIS",
          "KAB_KTP": "KOTA BANDUNG",
          "TEMPAT_LAHIR": "PAPUA",
          "KODEPOS_KTP": "40777",
          "NAMA": "NGOLO KANTE",
          "REQ_ID": "12121212",
          "KEC_KTP": "BANDUNG WETAN",
          "TGL_LAHIR": "02-02-1992",
          "NO_HP": "082166661666",
          "KEL_KTP": "CITARUM",
          "EMAIL": "",
          "ALAMAT_KTP": "JL.SULTAN NGABDUL KAMIT NO.34"
        },
      })
    } else {
      const data = qs.stringify({
        nik: NIK, 
        noHp: NoPonsel, 
        namaKtp: NamaLengkap, 
        tglLahir: moment(`${TglLahir}-${BlnLahir}-${ThnLahir}`, 'DD-MM-YYYY').format('DD-MM-YYYY')
      })
      const verification = await request('verifikasipeserta', 'post', data)
      // console.log(verification)
      if (verification.data.ret === 0) {
        const smsotp = verification.data.data.SMS_OTP
        // console.log(`Verification`,verification.data.data)
        // sent data contain address in verification
        resolve({
          status: 'success',
          smsotp,
          data: verification.data.data
        })
      } else {

        if (verification.data.msg === 'Error: java.net.SocketTimeoutException: Read timed out') {
          verification.data.msg = 'gagal menghubungi server'
        }

        const error = verification.data.msg
        reject({
          status: 'error',
          msg: error
        })
      }
    }
  })

export default verifyKTP


// WEBPACK FOOTER //
// ./src/bpjs-api/verify-ktp.js